<template>
  <IQOS 
    :title="$t('inside.self_serve.turn_on')"
    :readonly="false"
    :class="{
        'iqos-transparent': !isActive
    }">
      <p class="comment c-grey pt-0">
          {{$t('inside.self_serve.if_turned_on')}}
      </p>
      <!-- <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" /> -->
  
    <IQOSToggle v-model="isActive"/>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS";
import IQOSActions from "@/components/IQOSActions";

import IQOSToggle from "@/components/IQOSToggle.vue"

// import RoundCheckbox from "@/components/RoundCheckbox.vue"

export default {
    data() {
        return {
            editing: false,

            self_service: false
        }
    },
    methods: {
        // showEditUI() {  
        //     this.editing = true;
        // },
        // hideEditUI() {
        //     this.editing = false;
        //     this.resetValues();
        // },
        // onEditFinish() {
            

        //     this.editing = false;
        // },
        // resetValues() {
        //     if (this.cafe) {
        //         this.self_service = this.cafe.self_service || false;
        //     }
        // },
        // onToggle(arg) {            
        //     this.self_service = arg;

        //     this.onEditFinish();
        // }
    },
    mounted() {
        // this.resetValues();
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        },
        isActive: {
            get() {
                return this.cafe.self_service || false;
            },
            set(value) {
                this.$store.commit('setInsideSelfService', value);
                this.$store.dispatch('saveCafe');
            }
        }
    },
    components: {
        IQOS,
        IQOSActions,
        // RoundCheckbox,
        IQOSToggle
    }
}
</script>

<style scoped>
.first-comment {
    padding-top: 0 !important;
}
</style>